"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var highSentimentThreshold = 0.8;
var autoEscalateThreshold = -0.8;

function updateSettings(helpBotRef, msg) {
  helpBotRef.setState({

    highSentimentThreshold: msg.payload.fields.highSentimentThreshold ? msg.payload.fields.highSentimentThreshold.numberValue : this.highSentimentThreshold,

    autoEscalateThreshold: msg.payload.fields.autoEscalateThreshold ? msg.payload.fields.autoEscalateThreshold.numberValue : this.autoEscalateThreshold
  });
}

exports.default = {
  highSentimentThreshold: highSentimentThreshold,
  autoEscalateThreshold: autoEscalateThreshold,
  updateSettings: updateSettings
};